module.exports = __webpack_public_path__ + "static/img/img_center_back.97b97cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/img_center_back.png
// module id = nMM7
// module chunks = 1